import { s__ } from '~/locale';

export const FEATURE_NAME = s__('MlExperimentTracking|Machine learning experiment tracking');

export const FEATURE_FEEDBACK_ISSUE = 'https://gitlab.com/gitlab-org/gitlab/-/issues/381660';
